<template>
	<div id="identification-container">
		<div class="w-full py-4 px-4 flex items-stretch gap-3">
			<div class="flex items-stretch">
				<button
					type="button"
					class="btn btn-light btn-organization-id"
				>
					<span class="font-48">
						{{ organization.name.substring(0, 1) }}
					</span>
				</button>
			</div>
			<div class="col">
				<h4 class="font-24 font-md-32">
					{{ organization.name }}
				</h4>
				<div class="w-full flex items-center gap-5">
					<div class="flex flex-col">
						<small class="font-16 font-bold">SCHEMA</small>
						<span class="text-dark font-14 font-bold">{{
							organization.instances[0].config.schema_name
						}}</span>
					</div>
					<div class="flex flex-col">
						<small class="font-16 font-bold">{{
							organization.account_type == 2 ? `CNPJ` : `CPF`
						}}</small>
						<span class="text-dark font-14 font-bold">{{
							organization.document_number
						}}</span>
					</div>
					<div class="flex flex-col">
						<small class="font-16 font-bold">CRIAÇÃO</small>
						<span class="text-dark font-14 font-bold">{{
							ParseDate(organization.created_at)
						}}</span>
					</div>
					<div class="flex flex-col">
						<small class="font-16 font-bold">STATUS</small>
						<span
							class="text-dark font-14 font-bold badge"
							:class="{
								'badge-success': organization.status,
								'badge-danger': !organization.status,
							}"
							>{{
								organization.status ? 'ATIVA' : 'INATIVA'
							}}</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Helpers from '../../../helpers'
	const helpers = new Helpers()

	export default {
		name: 'Identification',
		props: {
			organization: {
				type: Object,
				required: true,
			},
		},
		methods: {
			ParseDate(date) {
				return helpers.ParseDate(date)
			},
		},
	}
</script>

<style lang="scss" scoped>
	#identification-container {
		width: 100%;
		border-bottom: 1px solid var(--elementsBorderColor);

		.btn-organization-id {
			height: unset;
			width: 6.6rem;
		}
	}
</style>
